import service from '@/api';
import { GlobalStore } from '@/store';
import axios from 'axios';

export const getMainMessage = async (callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/my-page/message/list/1?period=DAY_0',
        method: 'get',
        // data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

export const getMainMessage2 = async () => {
    try {
        const res = await service({
            url: '/api/my-page/message/list/1?period=DAY_0',
            method: 'get',
        });
        return res;
    } catch (e) {
        return null;
    }
};

export const getPassWordCheck = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/my-page/password/check',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

export const postPassWordUpdate = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        // url: '/api/my-page/password/update',
        url: '/api/my-page/password/chk-update',
        method: 'post',
        data: params,
    });
    if (data) return callback(data);
    return null;
};
export const postPassWordUpdateSkip = async (callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        // url: '/api/my-page/password/update',
        url: '/api/my-page/password/update-skip',
        method: 'post',
        // data: params,
    });
    if (data) return callback(data);
    return null;
};

export const loginApi = async (params, callback, err) => {
    const globalStore = GlobalStore();
    // const { data } = await service.post(`/api/user/login`, { params });
    const { data } = await service({
        url: '/api/user/login',
        method: 'post',
        data: params,
    });
    if (data && `${data?.statusCode}` === `200`) {
        return callback(data.data);
    } else {
        if (err && typeof err === 'function') {
            err();
        }
    }
};

/**  2023-12-22 pby KRT-2145 체험계정 로그인 로직 변경  */
export const trialAccountLogin = async (params, callback) => {
    try {
        const { data } = await service({
            url: '/api/trialAccountLogin',
            method: 'post',
            data: params,
        });
        if (data && `${data?.statusCode}` === `200`) {
            return callback(data.data);
        }
    } catch (e) {
        return e.response ? e.response : null;
    }
};

export const logoutApi = async (callback) => {
    const globalStore = GlobalStore();
    // const { data } = await service.post(`/api/user/login`, { params });
    const { data } = await service({
        url: '/api/user/logout',
        method: 'post',
    });
    if (data) return callback(data.data);
};

export const getUserInfo = async (callback) => {
    try {
        const { data } = await service.get('/api/user/info');
        if (data?.statusCode == 200) return callback(data.data);
    } catch (error) {
        console.log(`getUserInfo error: ${error}`);
    }
};

export const getUserJson = async (params, callback) => {
    //2023-11-15 pby radis 조회 파라미터 추가
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/user/get-user-json',
        method: 'get',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

//2023-11-20 pby radis 조회용 추가
export const getUserRedis = async (key, callback) => {
    const { data } = await service({
        url: '/api/user/get-user-redis',
        method: 'post',
        data: {
            key: key,
        },
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

//2023-11-20 pby radis 저장용 추가
export const setUserRedis = async (key, value, callback) => {
    try {
        const { data } = await service({
            url: '/api/user/save-user-redis',
            method: 'post',
            data: {
                key: key,
                value: value,
            },
        });
        if (data?.statusCode == 200) return callback(data.data);
    } catch (error) {
        console.log(`setUserRedis error: ${error}`);
    }
};

export const postUserJson = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/user/save-user-json',
        method: 'post',
        data: { json: params },
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

export const getUserMain = async (callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/user/main',
        method: 'get',
        // data: params,
    });
    // const data1 = {
    //     "statusCode": "200",
    //     "message": "성공",
    //     "data": {
    //       "exprVersion": "1.01.10",
    //       "level": 3,
    //       "lesson": 96,
    //       "isAllCourseCompleted": false,
    //       "studyMain": []
    //     }
    //   }
    // return callback(data1);
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) {
        return callback(data.data);
    } else if (data && (data?.statusCode === 842 || data?.statusCode === '842')) {
        return callback('noLevel');
    }
    return null;
};

export const getUserMain2 = async () => {
    try {
        const res = await service({
            url: '/api/user/main',
            method: 'get',
        });
        return res;
    } catch (e) {
        return null;
    }
};

/**  성장판 학습 로그인  */
export const growthplateLogin = async (params) => {
    try {
        const res = await service({
            url: `/api/growthplateLogin`,
            method: 'post',
            data: params,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  성장판 로그아웃 (홈화면)  */
export const growthplateLogout = async (params) => {
    try {
        const res = await service({
            url: `/api/growth/logout`,
            method: 'get',
            data: params,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  성장판 로그아웃 (자기점검)  */
export const growthplateFinish = async (params) => {
    try {
        const res = await service({
            url: `/api/growth/learning/summary`,
            method: 'post',
            data: params,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  성장판 로그아웃 (자기점검 - 진단평가)  */
export const growthplateFinishDignostic = async (params) => {
    try {
        const res = await service({
            url: `/api/growth/learning/summary/diagnostic`,
            method: 'post',
            data: params,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

export const checkServiceApi = async () => {
    try {
        const res = await service({
            url: `/api/user/check-token`,
            method: 'get',
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
